module.exports = __webpack_public_path__ + "static/media/UP_nieakt.40ea4303.svg";